module.exports = __webpack_public_path__ + "static/opteditor-19c0b0467d39e1c3caf26f5019ba3e92.jpg";